<template>
  <div>
    <b>精城商户服务平台</b>
  </div>
</template>

<script>
  export default {
    name: 'Dashboard',
    data() {
      return {}
    }
  }
</script>




// WEBPACK FOOTER //
// src/main/home/Dashboard.vue